import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const Status = () => <PublicStaticPage pageKey="status" />;

export default Status;
